export const catalogVisitorTypes = [
  { catalog_id: 122, value: 'V' },
  { catalog_id: 123, value: 'AG' },
  { catalog_id: 124, value: 'TC' },
  { catalog_id: 125, value: 'CL' },
  { catalog_id: 126, value: 'NN' },
];
